import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Typography } from '@material-ui/core';

import TextField from '../../../../../../Common/UI/TextField';
import SelectTextField from '../../../../../../Common/UI/SelectTextField';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from '@material-ui/pickers';

/* The Date Pickers actually hold an internal state of what the text field is. If the value of date picker is a
* invalid date then it falls back on the last state of this textfield, overall there is work around with the
* exception that clearing a character in a fully completed date will clear the full date */

const dateFns = new DateFnsUtils();

class DateRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleDate0Change = this.handleDate0Change.bind(this);
        this.handleDate1Change = this.handleDate1Change.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.renderTextFieldComponent = this.renderTextFieldComponent.bind(this);
    }

    handleChange (event) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.value
        };
        onChange(newTree);
    }

    handleDate0Change (date) {
        this.handleDateChange('value0', date);
    }

    handleDate1Change (date) {
        this.handleDateChange('value1', date);
    }

    componentDidMount(){
        const { tree, onChange } = this.props;
        const operator = tree.properties?.operator;
        const fromDate = new Date(tree.properties?.value0);
        const toDate = new Date(tree.properties?.value1);
        if(operator === "between" && (tree.properties?.value0 === undefined || tree.properties?.value1 === undefined)) tree['isValid'] = false;
        if(operator === "between" && (fromDate < toDate)) tree['isValid'] = true;
        if(operator === "between" && (fromDate > toDate)) tree['isValid'] = false;
        onChange(tree);
    }

    handleDateChange (name, date) {
        const { tree, field, onChange } = this.props;
        const newTree = { ...tree };
        // Only save a valid date to the tree
        newTree.properties = {
            ...newTree.properties,
            [name]: (!isNaN(date) && date != null) ?
                dateFns.format(date, (field.settings && field.settings.format) || 'yyyy-MM-dd' ) :
                null
        };
        const operator = newTree.properties?.operator;
        const fromDate = new Date(newTree.properties?.value0);
        const toDate = new Date(newTree.properties?.value1);
        if(operator === "between" && (newTree.properties?.value0 === undefined || newTree.properties?.value1 === undefined)) newTree['isValid'] = false;
        if(operator === "between" && (fromDate < toDate)) newTree['isValid'] = true;
        if(operator === "between" && (fromDate > toDate)) newTree['isValid'] = false;
        onChange(newTree);
    }

    renderTextFieldComponent (props) {
        return <TextField
            type="text"
            style={{ width: '150px' }}
            size="small"
            {...props}
            // error={props.error || error from backend}
            helperText={undefined} // No helper text yet, breaks styling
            variant={'outlined'} // Ensure it always is outlined
        />;
    }

    render () {
        const { tree, field } = this.props;
        const { properties } = tree;
        const format = (field.settings && field.settings.format) || 'yyyy-MM-dd';
        const mask = format.replace(/[yMd]/g, '_');

        return (
            <>
                <SelectTextField
                    name="operator"
                    size="small"
                    onChange={this.handleChange}
                    value={properties.operator || ''}
                    placeholder="Operator"
                >
                    <MenuItem value="after">{'After'}</MenuItem>
                    <MenuItem value="before">{'Before'}</MenuItem>
                    <MenuItem value="between">{'Between'}</MenuItem>
                </SelectTextField>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <>
                        {
                            (properties.operator === 'after' || properties.operator === 'between') && <KeyboardDatePicker
                                name="value0"
                                disableToolbar
                                autoOk
                                placeholder={'1995-01-01'}
                                TextFieldComponent={this.renderTextFieldComponent}
                                onChange={this.handleDate0Change}
                                value={(properties.value0 != null && properties.value0 != '') ? properties.value0 : null}
                                mask={mask}
                                format={format}
                                KeyboardButtonProps={{ size:'small' }}
                                error={properties.operator === 'between' && new Date(properties.value1) < new Date(properties.value0)}
                            />
                        }
                        {
                            (properties.operator === 'between') && <Typography color="textPrimary">
                                and
                            </Typography>
                        }
                        {
                            (properties.operator === 'before' || properties.operator === 'between') && <KeyboardDatePicker
                                name="value1"
                                disableToolbar
                                autoOk
                                placeholder={dateFns.format(new Date(), format)}
                                TextFieldComponent={this.renderTextFieldComponent}
                                onChange={this.handleDate1Change}
                                value={(properties.value1 != null && properties.value1 != '') ? properties.value1 : null}
                                mask={mask}
                                format={format}
                                KeyboardButtonProps={{ size:'small' }}
                                error={properties.operator === 'between' && new Date(properties.value1) < new Date(properties.value0)}
                            />
                        }
                    </>
                </MuiPickersUtilsProvider>
            </>
        );
    }
}

export default DateRule;